import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard{

  constructor(private cookieService: CookieService, private router: Router, private userService : UserService) { }

  canActivate(): boolean {
    const tokenExists = this.userService.hasLocalSessionToken();
    if (!tokenExists) {
      this.router.navigate(['/login']); // Redirige a la página de inicio de sesión si no hay token
    } else{
      //this.router.navigate(['/home']);
    }
    return tokenExists;
  }

  /*canActivate(): boolean {
    const tokenExists = this.cookieService.check('sessionToken');
    if (!tokenExists) {
      this.router.navigate(['/login']); // Redirige a la página de inicio de sesión si no hay token
    } else{
      //this.router.navigate(['/home']);
    }
    return tokenExists;
  }*/
}